import { useEffect, useState } from 'react';

const SNACKBAR_CONTAINER_SELECTOR = ':scope > .notistack-SnackbarContainer';

/**
 * `hostEl` must be the element that directly wraps the `SnackbarProvider`
 */
export function useSnackbarContainerElement(hostEl: HTMLElement | null): HTMLElement | null {
  const [containerEl, setContainerEl] = useState<HTMLElement | null>(null);

  useEffect(() => {
    if (!hostEl) {
      setContainerEl(null);
      return;
    }

    const findContainer = () => setContainerEl(hostEl.querySelector<HTMLElement>(SNACKBAR_CONTAINER_SELECTOR));
    findContainer();

    const observer = new MutationObserver(findContainer);
    observer.observe(hostEl, { childList: true });
    return () => observer.disconnect();
  }, [hostEl]);

  return containerEl;
}
